import { Directive, input, output, signal } from '@angular/core';

@Directive({
  selector: '[uploadDropzone]',
  host: {
    class: 'dropzoneBox',
    /** Class is applied to the host element when a drag is currently over the target. */
    '[class.drop-zone-active]': 'isActive()',
    '(drop)': 'onDrop($event)',
    '(dragover)': 'onDragOver($event)',
    '(dragleave)': 'isActive.set(false)',
    '(body:dragover)': 'onBodyDragOver($event)',
    '(body:drop)': 'onBodyDrop($event)',
  },
})
export class DropZoneDirective {
  protected readonly fileDrop = output<Array<File>>({ alias: 'uploadDropzone' });
  protected readonly preventBodyDrop = input(true);

  public readonly isActive = signal(false);

  protected onDrop(event: DragEvent) {
    event.preventDefault();
    this.isActive.set(false);
    const { dataTransfer } = event;
    if (dataTransfer.items) {
      const files = Array.from(dataTransfer.items).flatMap(item => (item.kind == 'file' ? [item.getAsFile()] : []));
      dataTransfer.items.clear();
      this.fileDrop.emit(files);
    } else {
      const files = Array.from(dataTransfer.files);
      dataTransfer.clearData();
      this.fileDrop.emit(files);
    }
  }

  protected onDragOver(event: DragEvent) {
    this.isActive.set(true);
    event.stopPropagation();
    event.preventDefault();
  }

  protected onBodyDragOver(event: DragEvent) {
    if (this.preventBodyDrop()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  protected onBodyDrop(event: DragEvent) {
    if (this.preventBodyDrop()) {
      event.preventDefault();
    }
  }
}
